// extracted by mini-css-extract-plugin
export var docHeader = "ContentHeader-module--docHeader--3e392";
export var headerItem = "ContentHeader-module--headerItem--0c6bd";